// // frontend/src/App.js
// import React from 'react';
// import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
// import { AuthProvider } from './contexts/AuthContext';
// import { NotificationProvider } from './contexts/NotificationContext';

// import Home from './pages/Home';
// import About from './pages/About';
// import Dashboard from './pages/Dashboard';
// import Internships from './pages/Internships';
// import Notices from './pages/Notices';
// import Documents from './pages/Documents';
// import Calendar from './pages/Calendar';
// import AIChatbot from './pages/AIChatbot';
// import Chat from './pages/Chat';
// import Login from './pages/Login';
// import Register from './pages/Register';
// import AdminPanel from './pages/AdminPanel';
// import TeacherQuizCreation from './pages/TeacherQuizCreation';
// import Leaderboard from './pages/Leaderboard';
// import Quiz from './pages/Quiz';
// import StudentQuizHome from './pages/StudentQuizHome';
// import NotificationsPage from './pages/NotificationsPage';
// import Unauthorized from './pages/Unauthorized';
// import RoleProtectedRoute from './components/RoleProtectedRoute';
// import Navbar from './components/Navbar';
// import TeacherAssignmentCreation from './pages/TeacherAssignmentCreation';
// import StudentAssignmentSubmission from './pages/StudentAssignmentSubmission';
// import AssignmentsList from './pages/AssignmentsList';
// import GradeSubmissions from './pages/GradeSubmissions';
// import StudentSubmissions from './pages/StudentSubmissions';
// import PerformanceDashboard from './components/PerformanceDashboard';
// import ResourceSharingHub from './components/ResourceSharingHub';


// function App() {
//   return (
//     <AuthProvider>
//       <NotificationProvider>
//         <Router>
          
//           <div>
//             <Navbar/>
//             <Routes>
//               <Route path="/" element={<Home />} />
//               <Route path="/about" element={<About />} />
//               <Route path="/dashboard" element={<Dashboard />} />
//               <Route path="/internships" element={<Internships />} />
//               <Route path="/notices" element={<Notices />} />
//               <Route path="/documents" element={<Documents />} />
//               <Route path="/calendar" element={<Calendar />} />
//               <Route path="/ai-chatbot" element={<AIChatbot />} />
//               <Route path="/chat" element={<Chat />} />
//               <Route path="/login" element={<Login />} />
//               <Route path="/register" element={<Register />} />
//               <Route path="/unauthorized" element={<Unauthorized />} />
//               <Route path="/quiz" element={<Quiz />} />
//               <Route path="/quiz/leaderboard" element={<Leaderboard />} />
//               <Route path="/teacher-dashboard" element={<RoleProtectedRoute role="teacher"><Dashboard /></RoleProtectedRoute>} />
//               <Route path="/admin" element={<AdminPanel />} />
//               <Route path="/teacher-quiz-create" element={<TeacherQuizCreation />} />
//               <Route path="/student-quiz-home" element={<StudentQuizHome />} />
//               <Route path="/notifications" element={<NotificationsPage />} />
//               <Route path="/teacher-assignment-create" element={<TeacherAssignmentCreation />} />
//               <Route path="/student-assignment-submit" element={<StudentAssignmentSubmission />} />
//               <Route path="/assignments" element={<AssignmentsList />} />
//               <Route path="/grade-submissions" element={<GradeSubmissions />} />
//               <Route path="/mysubmissions" element={<StudentSubmissions />} />
//               <Route path="/performance-dashboard" element={<PerformanceDashboard/>}/>
//               {/* <Route path="/performance-dashboard" element={<RoleProtectedRoute role="teacher"><PerformanceDashboard /></RoleProtectedRoute>} /> */}
//               <Route path="/resources" element={<ResourceSharingHub />} />


//             </Routes>
//           </div>
//         </Router>
//       </NotificationProvider>
//     </AuthProvider>
//   );
// }

// export default App;


// frontend/src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { NotificationProvider } from './contexts/NotificationContext';

import Home from './pages/Home';
import About from './pages/About';
import Dashboard from './pages/Dashboard';
import Internships from './pages/Internships';
import Notices from './pages/Notices';
import Documents from './pages/Documents';
import Calendar from './pages/Calendar';
import AIChatbot from './pages/AIChatbot';
import Chat from './pages/Chat';
import Login from './pages/Login';
import Register from './pages/Register';
import AdminPanel from './pages/AdminPanel';
import TeacherQuizCreation from './pages/TeacherQuizCreation';
import Leaderboard from './pages/Leaderboard';
import Quiz from './pages/Quiz';
import StudentQuizHome from './pages/StudentQuizHome';
import NotificationsPage from './pages/NotificationsPage';
import Unauthorized from './pages/Unauthorized';
import RoleProtectedRoute from './components/RoleProtectedRoute';
import Navbar from './components/Navbar';
import TeacherAssignmentCreation from './pages/TeacherAssignmentCreation';
import StudentAssignmentSubmission from './pages/StudentAssignmentSubmission';
import AssignmentsList from './pages/AssignmentsList';
import GradeSubmissions from './pages/GradeSubmissions';
import StudentSubmissions from './pages/StudentSubmissions';
import PerformanceDashboard from './components/PerformanceDashboard';
import ResourceSharingHub from './components/ResourceSharingHub';
import Profile from './pages/profile';


function App() {
  return (
    <AuthProvider>
      <NotificationProvider>
        <Router>
          <div>
            <Navbar />
            <Routes>
              {/* Public Routes */}
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/unauthorized" element={<Unauthorized />} />
              <Route path="/quiz" element={<Quiz />} />
              <Route path="/quiz/leaderboard" element={<Leaderboard />} />

              {/* Authenticated routes */}
              <Route 
                path="/teacher-dashboard" 
                element={
                  <RoleProtectedRoute role="teacher">
                    <Dashboard />
                  </RoleProtectedRoute>
                } 
              />
              <Route 
                path="/teacher-quiz-create" 
                element={
                  <RoleProtectedRoute role="teacher">
                    <TeacherQuizCreation />
                  </RoleProtectedRoute>
                } 
              />
              <Route 
                path="/teacher-assignment-create" 
                element={
                  <RoleProtectedRoute role="teacher">
                    <TeacherAssignmentCreation />
                  </RoleProtectedRoute>
                } 
              />
              <Route 
                path="/grade-submissions" 
                element={
                  <RoleProtectedRoute role="teacher">
                    <GradeSubmissions />
                  </RoleProtectedRoute>
                } 
              />
              <Route 
                path="/performance-dashboard" 
                element={
                  <RoleProtectedRoute role="teacher">
                    <PerformanceDashboard />
                  </RoleProtectedRoute>
                } 
              />

              <Route 
                path="/student-quiz-home" 
                element={
                  <RoleProtectedRoute role="student">
                    <StudentQuizHome />
                  </RoleProtectedRoute>
                } 
              />
              <Route 
                path="/student-assignment-submit" 
                element={
                  <RoleProtectedRoute role="student">
                    <StudentAssignmentSubmission />
                  </RoleProtectedRoute>
                } 
              />
              <Route 
                path="/mysubmissions" 
                element={
                  <RoleProtectedRoute role="student">
                    <StudentSubmissions />
                  </RoleProtectedRoute>
                } 
              />

              {/* Other Routes */}
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/internships" element={<Internships />} />
              <Route path="/notices" element={<Notices />} />
              <Route path="/documents" element={<Documents />} />
              <Route path="/calendar" element={<Calendar />} />
              <Route path="/ai-chatbot" element={<AIChatbot />} />
              <Route path="/chat" element={<Chat />} />
              <Route path="/notifications" element={<NotificationsPage />} />
              <Route path="/assignments" element={<AssignmentsList />} />
              <Route path="/resources" element={<ResourceSharingHub />} />
              <Route path="/admin" element={<AdminPanel />} />
              <Route path="/profile" element={<Profile />} />

            </Routes>
          </div>
        </Router>
      </NotificationProvider>
    </AuthProvider>
  );
}

export default App;
